import React, { useEffect, useState } from 'react'

const Home = () => {

    useEffect(() => {
        document.title = 'AmanChauhan'
    })

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loader = document.getElementById("preloader");

        const handleLoad = () => {
            setTimeout(() => {
                setLoading(false);
            }, 1000);
            if (loader) {
                loader.style.display = "none";
            }
        };

        const isMobile = window.innerWidth <= 840;

        if (isMobile) {
            handleLoad();  // Directly call handleLoad for mobile devices
        } else if (document.readyState === 'complete') {
            // If the document is already loaded, call handleLoad immediately
            handleLoad();
        } else {
            window.addEventListener("load", handleLoad);
        }

        return () => {
            window.removeEventListener("load", handleLoad);
        };
    }, []); // Empty dependency array means this effect runs once on component mount

    return (
        <>
            {loading ? (
                <div id="preloader" className='preloader'>
                    <img src="../IMG/Aman.png" className='preload-img' alt="AMAN CHAUHAN" />
                    <h2 className='preload-heading'>AMAN CHAUHAN</h2>
                </div>
            ) :
                <section id="Me">
                    <div className="Profile--Container">
                        <div className="Profile" data-aos="fade-right" data-aos-duration="1000">
                            <div className="MyImage"></div>
                            <h1 className="Profile--Name">Aman Chauhan</h1>
                            <p className="Profile--shortinfo">-- Web Developer</p>
                            <p className="Profile--shortinfo">-- App Developer</p>
                            <p className="Profile--shortinfo">-- ML/AI Enthusiast</p>
                            <div className="Profile--Socials">
                                <a href="https://github.com/Chauhan-Aman" target='__blank'><i className="fa-brands fa-beat fa-github"></i></a>
                                <a href="https://discord.gg/gkazYgcZ" target='__blank'><i className="fa-brands fa-beat fa-discord"></i></a>
                                <a href="https://www.linkedin.com/in/aman-chauhan-779955256/" target='__blank'><i className="fa-brands fa-beat fa-linkedin-in"></i></a>
                                <a href="https://x.com/ChauhanAman03" target='__blank'><i className="fa-brands fa-beat fa-x-twitter"></i></a>
                                <a href="https://www.instagram.com/aman.chauhnn/" target='__blank'><i className="fa-brands fa-beat fa-instagram"></i></a>
                            </div>
                        </div>
                        <div className="Profile--info">
                            <h1 data-aos="fade-left" data-aos-duration="1200">Hello</h1>
                            <div className="About-Me" data-aos="slide-up" data-aos-duration="1000">
                                <span></span>
                                <p>About Me</p>
                            </div>
                            <div className="About-Me-txt">
                                <p data-aos="fade-up" data-aos-duration="1000">
                                    I am a versatile professional, skilled in both frontend and backend web and app development. With a passion for crafting seamless user experiences and a knack for diving deep into code, I create dynamic and engaging websites and apps that blend functionality with aesthetics.
                                </p>
                                <p data-aos="fade-up" data-aos-duration="1000">
                                    Beyond app and web development, I am also passionate about machine learning and artificial intelligence. By leveraging the latest advancements in ML/AI, I aim to enhance web applications with intelligent features, making them more responsive, adaptive, and user-friendly.
                                </p>
                                <p data-aos="fade-up" data-aos-duration="1000">
                                    My combined expertise in web development and ML/AI allows me to navigate the digital realm from both creative and intelligent standpoints, providing comprehensive solutions that marry innovation with cutting-edge technology.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
            }

        </>
    )
}

export default Home